import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';

export default function LeadershipPage() {
  return (
    <div className="min-h-screen bg-white">
      <Header />

      {/* Hero Section */}
      <section className="relative py-20 bg-gradient-to-r from-[#b8144a] to-[#d91e5b] text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-5xl font-bold mb-6">Leadership</h1>
          <p className="text-xl max-w-4xl mx-auto">
            Meet the apostolic leadership called by God to gather the Ecclesia and teach the saints the Way of the Lord
          </p>
        </div>
      </section>

      {/* Apostle Peter Akinnubi */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div className="relative">
              <img 
                src="https://static.readdy.ai/image/0f4196e35f78d87056a996d208b7f641/10437a960a01189954d6772fe2c1a766.jpeg"
                alt="Apostle Peter O. Akinnubi"
                className="rounded-lg shadow-2xl object-cover w-full h-[500px] object-top"
              />
            </div>
            <div>
              <h2 className="text-4xl font-bold text-gray-900 mb-4">Apostle Peter O. Akinnubi</h2>
              <p className="text-xl text-[#b8144a] font-semibold mb-6">
                Presiding International President, Peter Akinnubi Apostolic Ministry (PAAM)
              </p>
              <p className="text-lg text-[#b8144a] font-medium mb-6">
                Founder, Ecclesia of Believers International
              </p>
              
              <div className="prose prose-lg text-gray-700">
                <p className="text-lg leading-relaxed mb-6">
                  Apostle Peter O. Akinnubi is a Christ-centered apostle, visionary leader, and global reformer 
                  raised by God to gather the Ecclesia and teach the saints the Way of the Lord. Called into 
                  ministry in 1993 through a divine encounter, Apostle Peter received the apostolic mandate to 
                  raise a generation of disciples grounded in the doctrine of Christ, marked by purity, unity, 
                  and sound doctrine.
                </p>
                <p className="text-lg leading-relaxed mb-6">
                  His calling echoes the heavenly blueprint—from Moses to Messiah—and his life's assignment 
                  has been to build according to that pattern. Through PAAM, thousands are being discipled 
                  across continents through teachings, fellowships, crusades, rural missions, and publishing initiatives.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Education & Business Leadership */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
            {/* Education */}
            <div className="bg-white p-8 rounded-lg shadow-lg">
              <div className="flex items-center mb-6">
                <div className="w-12 h-12 bg-[#b8144a] rounded-full flex items-center justify-center mr-4">
                  <i className="ri-graduation-cap-line text-white text-xl"></i>
                </div>
                <h3 className="text-2xl font-bold text-gray-900">Academic Excellence</h3>
              </div>
              <div className="space-y-4">
                <div className="border-l-4 border-[#b8144a] pl-4">
                  <h4 className="font-semibold text-gray-900">Master's Degree</h4>
                  <p className="text-gray-700">Procurement, Logistics, and Global Supply Chain Management</p>
                  <p className="text-sm text-gray-600">University of Salford, Manchester, UK</p>
                </div>
                <div className="border-l-4 border-[#b8144a] pl-4">
                  <h4 className="font-semibold text-gray-900">Bachelor's Degree</h4>
                  <p className="text-gray-700">Business Administration (International Business)</p>
                  <p className="text-sm text-gray-600">Nexford University, USA</p>
                </div>
              </div>
            </div>

            {/* Business Leadership */}
            <div className="bg-white p-8 rounded-lg shadow-lg">
              <div className="flex items-center mb-6">
                <div className="w-12 h-12 bg-[#b8144a] rounded-full flex items-center justify-center mr-4">
                  <i className="ri-building-line text-white text-xl"></i>
                </div>
                <h3 className="text-2xl font-bold text-gray-900">Business Leadership</h3>
              </div>
              <p className="text-gray-700 mb-4">Group CEO of Tinpet Groups Limited, a global conglomerate with subsidiaries:</p>
              <div className="space-y-3">
                <div className="flex items-start space-x-3">
                  <i className="ri-plant-line text-[#b8144a] mt-1"></i>
                  <div>
                    <h5 className="font-medium text-gray-900">Tinpet Multitrading Ltd</h5>
                    <p className="text-sm text-gray-600">Agricultural & Mineral Export</p>
                  </div>
                </div>
                <div className="flex items-start space-x-3">
                  <i className="ri-bank-line text-[#b8144a] mt-1"></i>
                  <div>
                    <h5 className="font-medium text-gray-900">Tinpet Financial Services Ltd</h5>
                    <p className="text-sm text-gray-600">Finance and Micro-credit</p>
                  </div>
                </div>
                <div className="flex items-start space-x-3">
                  <i className="ri-building-2-line text-[#b8144a] mt-1"></i>
                  <div>
                    <h5 className="font-medium text-gray-900">Tinpet Infrastructural Services Ltd</h5>
                    <p className="text-sm text-gray-600">Real Estate & Infrastructure</p>
                  </div>
                </div>
                <div className="flex items-start space-x-3">
                  <i className="ri-hospital-line text-[#b8144a] mt-1"></i>
                  <div>
                    <h5 className="font-medium text-gray-900">Tinpet PharmaMetrics Suppliers Ltd</h5>
                    <p className="text-sm text-gray-600">Medical Equipment Procurement</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Kingdom First Philosophy */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold text-gray-900 mb-6">Kingdom First</h2>
            <div className="max-w-4xl mx-auto">
              <p className="text-xl text-gray-700 leading-relaxed mb-6">
                Despite his success in business, Apostle Peter is known for choosing the Kingdom first. 
                He has poured his life, resources, and vision into the advancement of God's Kingdom, 
                making ministry his foremost pursuit.
              </p>
              <p className="text-lg text-gray-700 leading-relaxed">
                His leadership is marked by spiritual fire, doctrinal clarity, selfless generosity, 
                and apostolic integrity. He combines apostolic wisdom with professional excellence, 
                equipping the saints in both ministry and marketplace influence.
              </p>
            </div>
          </div>

          {/* Published Works */}
          <div className="bg-gray-50 p-8 rounded-lg">
            <div className="text-center mb-8">
              <h3 className="text-2xl font-bold text-gray-900 mb-4">Published Works</h3>
              <p className="text-gray-600">Apostolic literature for global transformation</p>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div className="bg-white p-6 rounded-lg shadow-md text-center">
                <i className="ri-book-open-line text-[#b8144a] text-3xl mb-4"></i>
                <h4 className="text-xl font-bold text-gray-900 mb-2">From Moses to Messiah</h4>
                <p className="text-gray-700">The training mandate program for anyone joining this mandate across the globe</p>
              </div>
              <div className="bg-white p-6 rounded-lg shadow-md text-center">
                <i className="ri-book-line text-[#b8144a] text-3xl mb-4"></i>
                <h4 className="text-xl font-bold text-gray-900 mb-2">In Him: A Decade of Divine Mandates</h4>
                <p className="text-gray-700">Platforms for discipleship, leadership, and global transformation</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Pastor Clementina Akinnubi */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <h2 className="text-4xl font-bold text-gray-900 mb-4">Pastor Mrs. Clementina Akinnubi</h2>
              <p className="text-xl text-[#b8144a] font-semibold mb-6">
                International Director of Welfare and Family Affairs, PAAM
              </p>
              
              <div className="prose prose-lg text-gray-700">
                <p className="text-lg leading-relaxed mb-6">
                  Pastor Mrs. Clementina Akinnubi is a seasoned minister of the gospel, passionate intercessor, 
                  and a compassionate mother to both her family and the global PAAM community. As the International 
                  Director of Welfare and Family Affairs, she oversees the coordination of PAAM's global hospitality 
                  efforts, health and nutrition outreaches, and the welfare needs of ministry partners and missionary 
                  families across nations.
                </p>
                <p className="text-lg leading-relaxed mb-6">
                  She is a pillar of strength, wisdom, and warmth in the apostolic assignment. Through her leadership 
                  in the Meal and Medical Mission arm of PAAM, she has championed several empowerment programs, 
                  community food distributions, and medical outreach initiatives—bringing healing and hope to countless lives.
                </p>
              </div>
            </div>
            <div className="relative">
              <img 
                src="https://static.readdy.ai/image/0f4196e35f78d87056a996d208b7f641/06eb52daf946657d0f06cce734777cf1.jpeg"
                alt="Pastor Mrs. Clementina Akinnubi"
                className="rounded-lg shadow-2xl object-cover w-full h-[500px] object-top"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Pastor Clementina's Education & Ministry */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
            {/* Education */}
            <div className="bg-gray-50 p-8 rounded-lg">
              <div className="flex items-center mb-6">
                <div className="w-12 h-12 bg-[#b8144a] rounded-full flex items-center justify-center mr-4">
                  <i className="ri-graduation-cap-line text-white text-xl"></i>
                </div>
                <h3 className="text-2xl font-bold text-gray-900">Academic Background</h3>
              </div>
              <div className="space-y-4">
                <div className="border-l-4 border-[#b8144a] pl-4">
                  <h4 className="font-semibold text-gray-900">Postgraduate Diploma in Education (P.G.D.E)</h4>
                  <p className="text-sm text-gray-600">University of Ilorin, Nigeria</p>
                </div>
                <div className="border-l-4 border-[#b8144a] pl-4">
                  <h4 className="font-semibold text-gray-900">Bachelor of Science</h4>
                  <p className="text-gray-700">Agricultural Studies (Major in Crop Science)</p>
                  <p className="text-sm text-gray-600">Federal University of Technology, Minna, Nigeria</p>
                </div>
              </div>
              <p className="text-gray-700 mt-4">
                Her academic background blends scientific discipline with a nurturing spirit, 
                equipping her for both spiritual leadership and practical care.
              </p>
            </div>

            {/* Ministry Focus */}
            <div className="bg-gray-50 p-8 rounded-lg">
              <div className="flex items-center mb-6">
                <div className="w-12 h-12 bg-[#b8144a] rounded-full flex items-center justify-center mr-4">
                  <i className="ri-heart-pulse-line text-white text-xl"></i>
                </div>
                <h3 className="text-2xl font-bold text-gray-900">Ministry Focus</h3>
              </div>
              <div className="space-y-4">
                <div className="flex items-start space-x-3">
                  <i className="ri-hand-heart-line text-[#b8144a] mt-1"></i>
                  <div>
                    <h5 className="font-medium text-gray-900">Welfare Coordination</h5>
                    <p className="text-sm text-gray-600">Global hospitality efforts and missionary family care</p>
                  </div>
                </div>
                <div className="flex items-start space-x-3">
                  <i className="ri-restaurant-line text-[#b8144a] mt-1"></i>
                  <div>
                    <h5 className="font-medium text-gray-900">Meal and Medical Mission</h5>
                    <p className="text-sm text-gray-600">Community food distributions and medical outreach</p>
                  </div>
                </div>
                <div className="flex items-start space-x-3">
                  <i className="ri-user-heart-line text-[#b8144a] mt-1"></i>
                  <div>
                    <h5 className="font-medium text-gray-900">Spiritual Mentorship</h5>
                    <p className="text-sm text-gray-600">Counselor to women, children, and families</p>
                  </div>
                </div>
                <div className="flex items-start space-x-3">
                  <i className="ri-community-line text-[#b8144a] mt-1"></i>
                  <div>
                    <h5 className="font-medium text-gray-900">Empowerment Programs</h5>
                    <p className="text-sm text-gray-600">Teaching honor, holiness, and Christlike service</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Family Life */}
      <section className="py-20 bg-[#b8144a] text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center">
            <h2 className="text-4xl font-bold mb-8">A Kingdom Family</h2>
            <div className="max-w-4xl mx-auto">
              <p className="text-xl leading-relaxed mb-6">
                Apostle Peter and Pastor Mrs. Clementina Akinnubi are blessed with three children, 
                and together they serve as a Kingdom family, traveling across continents from their 
                base in Nigeria to be a blessing to nations.
              </p>
              <p className="text-lg leading-relaxed">
                Their home is a living testimony of grace, discipleship, and divine order—a pattern 
                for spiritual households around the world. They exemplify the values of honor, unity, 
                and sacrificial service that characterize the PAAM mandate.
              </p>
            </div>
            
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mt-12">
              <div className="text-center">
                <div className="w-16 h-16 bg-white/20 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-home-heart-line text-white text-xl"></i>
                </div>
                <h4 className="text-xl font-bold mb-2">Divine Order</h4>
                <p className="text-white/90">A pattern for spiritual households worldwide</p>
              </div>
              
              <div className="text-center">
                <div className="w-16 h-16 bg-white/20 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-earth-line text-white text-xl"></i>
                </div>
                <h4 className="text-xl font-bold mb-2">Global Ministry</h4>
                <p className="text-white/90">Traveling across continents to bless nations</p>
              </div>
              
              <div className="text-center">
                <div className="w-16 h-16 bg-white/20 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-group-line text-white text-xl"></i>
                </div>
                <h4 className="text-xl font-bold mb-2">Family Legacy</h4>
                <p className="text-white/90">Raising the next generation in apostolic truth</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}